// removed by extract-text-webpack-plugin
module.exports = {"home":"home","transitionContainer-home":"transitionContainer-home","wrapperNews":"wrapperNews","view":"view","content":"content"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/home.scss
// module id = 584
// module chunks = 0